jq_lumia('.gallery-fancybox-link').fancybox({
	loop: false,
	animationEffect: 'zoom',
	touch: false,
	thumbs: false,
	arrows: true,
	buttons : ['close'],
	btnTpl: {
		arrowLeft:'<button data-fancybox-prev class="fancybox-arrow-prev" title="{{PREV}}"></button>',
		arrowRight:'<button data-fancybox-next class="fancybox-arrow-next" title="{{NEXT}}"></button>',
	},
	beforeShow: function beforeShow() {
		jq_lumia('.fancybox-container').last().addClass('fancybox--light');
	}
})

document.querySelectorAll('.carousel-btn').forEach(button => {
  button.addEventListener('click', () => {
    const carouselId = button.dataset.carouselId;
    const direction = button.classList.contains('next') ? 1 : -1;
    
    if (button.classList.contains('shared')) {
      const carousels = document.querySelectorAll(`#${carouselId}`);
      carousels.forEach(carousel => {
        const scrollAmount = carousel.offsetWidth;
        carousel.scrollBy({ left: scrollAmount * direction, behavior: 'smooth' });
      });
    } else {
      
      const carousel = document.getElementById(carouselId);
      if (carousel) {
        const scrollAmount = carousel.offsetWidth;
        carousel.scrollBy({ left: scrollAmount * direction, behavior: 'smooth' });
      }
    }
  });
});
